// Sendbird Token
export const GET_SENDBIRD_TOKEN_REQUEST = 'GET_SENDBIRD_TOKEN_REQUEST';
export const GET_SENDBIRD_TOKEN_DONE = 'GET_SENDBIRD_TOKEN_DONE';
export const GET_SENDBIRD_TOKEN_FAILED = 'GET_SENDBIRD_TOKEN_FAILED';